import React, { useEffect } from 'react';
import JsBarcode from 'jsbarcode';

function BarCodeMultipleDownload({product}: any) {
    
    const customizeCanvas = () => {
        const canvas: any = document.querySelector('#barcode'+product.productId);
        const ctx = canvas.getContext('2d');
        const barcodeMargin = 40;
        JsBarcode(canvas, product.productId, {
            format: 'CODE128',
            ean128: false,
            margin: barcodeMargin,
            height: 40
        });
        const x = (-canvas.width / 2) + barcodeMargin;
        const y = barcodeMargin - (barcodeMargin / 2);

        ctx.fillStyle = 'black';
        ctx.textAlign = 'center';
        ctx.fillText(product.productName, x, y, canvas.width);
        ctx.fillText("Rs."+product.mrp, x, canvas.height - 10, canvas.width);
        canvas.addEventListener('click', download, false);
    }

    useEffect(() => {
        customizeCanvas()
    },[])

    const download = () => {
        let canvas: any = document.getElementById("barcode"+product.productId);
        const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = `${product.productId}.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    return (
        <div style={{height: "100px"}}>
            {/* <Barcode 
            value={"00400964000007"} 
            format="CODE128" /> */}
            {/* <QRCodeCanvas
                id="123456"
                value="Umar"
                size={290}
                level={"H"}
                includeMargin={true}
            /> */}
            {/* <a onClick={download}> Download QR </a> */}
            <canvas 
            style={{cursor: "pointer",maxHeight: "100%"}} 
            id={"barcode"+product.productId}></canvas>
        </div>
    );
}

export default BarCodeMultipleDownload;